import { axiosApi } from "../../../../../api/dbAxios";
import { IPrompt } from "../interfaces/prompt.interface";

export const updatePromptLibrary = async (prompt: any) => {
  try {
    const body = {
      ...prompt,
      team_id:
        prompt.team_id !== undefined
          ? prompt.team_id
          : prompt.team
          ? prompt.team.id
          : null,
    };
    const response = await axiosApi.put(`/prompt/${prompt.id}/`, body);
    return response.data;
  } catch (error: any) {
    let respData = error?.response?.data;

    if (typeof respData === "string") {
      const stripped = respData.replace(/^\)\]\}',\s*/, "");
      try {
        respData = JSON.parse(stripped);
      } catch (e) {
        respData = respData;
      }
    }

    if (respData && respData.team_id && Array.isArray(respData.team_id) && respData.team_id[0]) {
      throw "You must be a member of the selected team to assign this prompt.";
    }

    const message =
      respData?.detail ?? (typeof respData === "string" ? respData : undefined) ?? error?.message ?? String(error);
    throw message;
  }
};
